var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    {
      ref: "form_step_2",
      model: {
        value: _vm.form,
        callback: function($$v) {
          _vm.form = $$v
        },
        expression: "form"
      }
    },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { staticStyle: { "min-height": "400px" }, attrs: { cols: "12" } },
            [
              _c("renters-simple-list", { staticClass: "mt-5 mb-5" }),
              _vm._v(" "),
              _vm.notes_on_kiosk
                ? _c("additional-information-input")
                : _vm._e(),
              _vm._v(" "),
              _c(
                "h5",
                {
                  staticClass: "mt-15 font-weight-bold error--text text-break"
                },
                [
                  _vm._v(
                    '\n                Please check any of the individual reservations above, if correct, push "continue" to move to the checkout page.\n            '
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("steps-navigation", {
        attrs: {
          "error-messages-list": _vm.errorMessagesList,
          errors: _vm.v__getErrors(),
          "next-button": "Continue"
        },
        on: {
          "step-next": function($event) {
            return _vm.stepNext()
          },
          "step-back": function($event) {
            return _vm.stepBack({ validate: false, submit: false })
          }
        }
      }),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "800px" },
          model: {
            value: _vm.messageDialog.show,
            callback: function($$v) {
              _vm.$set(_vm.messageDialog, "show", $$v)
            },
            expression: "messageDialog.show"
          }
        },
        [
          _c("DoneMessageModal", {
            attrs: {
              message: _vm.messageDialog.message,
              success: _vm.messageDialog.success
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }